<template>
    <div class="priceBox">
        <ul class="priceRank">
            <el-divider></el-divider>
            <li v-for="record in quotationRecords" :key="record.userid">
                <p><strong>货代名称:</strong> {{ record.company }}</p>
                <p><strong>货代排名:</strong> {{ record.ranking }}</p>
                <p><strong>报价单价:</strong> {{ record.offerPrice }}</p>
                <p><strong>报价备注:</strong> {{ record.memo }}</p>
                <el-divider></el-divider>
            </li>
        </ul>
        <!-- <div class="priceBox" >
            <div class="priceRank" v-for="record in quotationRecords" :key="record.userid">
                <p>
                    <label>货代名称：</label>
                    <span>{{ record.company }}</span> 
                </p>
                <p>
                    <label>货代排名：</label>
                    <span>{{ record.ranking  }}</span>
                </p>  
                <p>
                    <label>报价单价：</label>
                    <span>{{ record.offerPrice  }}</span>
                </p>  
                <p>
                    <label>报价备注：</label>
                    <span>{{ record.memo  }}</span>
                </p>  
                <el-divider></el-divider>
            </div>
        </div> -->
    </div>
</template>

<script>
    export default {
        data() {
            return {
                quotationRecords: [],
                url: {
                    queryQuotationRecord: '/bookspaceinquiry/queryQuotationRecord',   //查询本单详情，get，传formid和type
                },
            };
        },
        mounted() {
            this.fetchQuotationRecords();
        },
        methods: {
            async fetchQuotationRecords() {
                try {
                    this.$get(this.url.queryQuotationRecord, this.$route.query).then(res => {
                        if(res.code === 200) {
                            this.quotationRecords = res.result
                        } else {
                            this.$message.error(res.message)
                        }
                    })
/*
                    const response = await fetch('http://10.16.83.32:9991/jeecg-boot/bookspaceinquiry/queryQuotationRecord?type=比价订舱&formid=肖邦20248221718');
                    const data = await response.json();
                    if (data.success) {
                        this.quotationRecords = data.result;
                    } else {
                        console.error(data.message);
                    }*/
                } catch (error) {
                    console.error(error);
                }
            }
        }
    };
</script>

<style scoped lang="less">
.priceBox {
    width: 100%;
    .el-divider--horizontal {
        margin: 16px 0;
    }
    .priceRank {
        padding: 2px 16px 0;
        label {
            font-weight: 550;
        }
        p {
            padding: 2px 0;
            color: rgb(46, 42, 42);
            font-size: 16px;
        }
    }
}
</style>
